let root = {};
export const date = new Date(); //new Date("December 16, 2016 11:13:00");//
export const time = date.getSeconds();
export const month = date.getMonth();
export const day = date.getDate();
export const xmas = month == 11 || (month == 0 && day <= 10); //between dec 1 and jan 10
export const hallow = month == 9 && day >= 10; //between oct 10 and oct 31	
export const viskey = 'visibility';
export const visval = 'visible';
export const xkey = 'x';
export const ykey = 'y';
export const hkey = 'height';
export const wkey = 'width';
const imagePaths = {};
const darkModeKey = "darkmode-text";
import hexRgb from 'hex-rgb';
export const svgNamespace = "http://www.w3.org/2000/svg";
export function applySavedDarkMode() {
    let dark = isDarkModeEnabled();
    applyDarkMode(dark);
    let newest = document.getElementById("darkmode-toggle");
    if (newest != null)
        newest.addEventListener("click", function () { toggleDarkMode(); });
}
export function loadCachedVariable(id) {
    try {
        return window.localStorage.getItem(id);
    }
    catch (e) {
        console.log("Error thrown accessing local storage: " + e?.toString());
        //alert("Failed to load stored settings for this page ("+e?.toString()+"). Are you blocking cookies?");
    }
}
export function loadCachedVariableAsBoolean(id) {
    let ret = loadCachedVariable(id);
    return ret != null ? ret === "true" : false;
}
export function loadCachedVariableAsBooleanOrNull(id) {
    let ret = loadCachedVariable(id);
    return ret != null ? ret === "true" : null;
}
export function saveCachedVariable(id, value) {
    try {
        window.localStorage.setItem(id, value);
    }
    catch (e) {
        console.log("Error thrown accessing local storage: " + e?.toString());
        alert("Could not access setting storage (see console for more info); your settings will not be preserved. Are you blocking all cookies?");
    }
}
function toggleDarkMode() {
    let has = isDarkModeEnabled();
    saveCachedVariable(darkModeKey, (!has).toString());
    applyDarkMode(!has);
}
export function isDarkModeEnabled() {
    return loadCachedVariableAsBoolean(darkModeKey);
}
function applyDarkMode(active) {
    console.log("Applying dark mode theming: " + active);
    applyDarkModeToElement(active, document.getElementById("textarea"));
    applyDarkModeToElement(active, document.getElementById("toc_container"));
    let elems = document.getElementsByClassName("core-body");
    for (var i = 0; i < elems.length; i++) {
        applyDarkModeToElement(active, elems[i]);
    }
    elems = document.getElementsByClassName("other-project-body");
    for (var i = 0; i < elems.length; i++) {
        applyDarkModeToElement(active, elems[i]);
    }
    window.document.dispatchEvent(new Event("resize", { bubbles: true, cancelable: true }));
}
function applyDarkModeToElement(active, elem) {
    if (elem == null)
        return;
    if (active) {
        elem.classList.add(darkModeKey);
    }
    else {
        elem.classList.remove(darkModeKey);
    }
}
export function getRandomMapKey(obj) {
    let keys = Object.keys(obj);
    return keys[keys.length * Math.random() << 0];
}
export function invokeMethod(m, name) {
    let idx = Object.keys(m).indexOf(name);
    if (idx >= 0)
        return Object.values(m)[idx]();
}
export function injectAtlasNode(elem, x, y, game, id, w, h, blend = null) {
    let forg = document.createElementNS(svgNamespace, "foreignObject");
    forg.setAttribute(wkey, w.toString());
    forg.setAttribute(hkey, h.toString());
    forg.setAttribute(xkey, x.toString());
    forg.setAttribute(ykey, y.toString());
    if (blend)
        forg.setAttribute("style", "mix-blend-mode: " + blend + ";");
    let div = document.createElement("div");
    div.setAttribute("xmlns", "http://www.w3.org/1999/xhtml");
    div.className = "tile-" + game + "-" + id;
    forg.appendChild(div);
    elem.appendChild(forg);
    return forg;
}
/* chrome cannot into SVG
export function generateSpritesheetSVGAtlasNode(elem:HTMLElement, game:string, name:string, w:number, h:number) {
    let ref = elem.getElementsByTagName("defs");
    let defs = null;
    if (ref != null && ref.length > 0) {
        defs = ref[0];
    }
    if (defs == null) {
        defs = document.createElementNS(svgNamespace, "defs");
        elem.appendChild(defs);
    }
    let g = document.createElementNS(svgNamespace, "g");
    g.id = name;
    let forg = document.createElementNS(svgNamespace, "foreignObject");
    forg.setAttribute("width", w.toString());
    forg.setAttribute("height", h.toString());
    let div = document.createElement("div");
    div.setAttribute("xmlns", "http://www.w3.org/1999/xhtml")
    div.className = "tile-"+game+"-"+name;
    forg.appendChild(div);
    g.appendChild(forg);
    defs.appendChild(g);
    return g;
}
*/
export function hexToRGB(hex) {
    let ret = hexRgb(hex.toLowerCase().replace("0x", "#"));
    return { r: ret.red, g: ret.green, b: ret.blue };
}
export function RGBtoHSV(r, g, b) {
    let max = Math.max(r, g, b), min = Math.min(r, g, b), d = max - min, h = 0, s = (max === 0 ? 0 : d / max), v = max / 255;
    switch (max) {
        case min:
            h = 0;
            break;
        case r:
            h = (g - b) + d * (g < b ? 6 : 0);
            h /= 6 * d;
            break;
        case g:
            h = (b - r) + d * 2;
            h /= 6 * d;
            break;
        case b:
            h = (r - g) + d * 4;
            h /= 6 * d;
            break;
    }
    return {
        h: h * 360,
        s: s,
        v: v
    };
}
export function fitBCG(elem, scale) {
    //elem.style.transform = "scale("+scale+", "+scale+") translate("+rows*w/4+"px, "+cols*h*0/4+"px)";
    elem.style.transformOrigin = "top left";
    elem.style.transform = "scale(" + scale + ")";
}
export function absDiff(a, b) {
    return Math.abs(Math.abs(a) - Math.abs(b));
}
export function getImageRoot(folderName) {
    if (root[folderName] == null || typeof (root[folderName]) == "undefined") {
        let ret = "images/" + folderName + "/";
        let url = window.location.href;
        //console.log(url);
        let idx = url.lastIndexOf("sitecore");
        if (idx == -1 && url.includes("Generator/exported")) {
            idx = url.lastIndexOf("exported");
        }
        url = url.substring(idx + 9);
        //console.log(url);
        let levels = url.split("/").length - 1;
        for (let i = 0; i < levels; i++)
            ret = "../" + ret;
        root[folderName] = ret;
        //console.log("Calculated root "+root[folderName]);
    }
    return root[folderName];
}
export function getRandomBetween(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
}
export function getRandomDecimalBetween(min, max) {
    return Math.random() * (max - min) + min;
}
export function getOrCreateImgPath(img, folder) {
    if (imagePaths[img] == null) {
        imagePaths[img] = getImageRoot(folder) + img + ".png";
        console.log("Computed image path '" + imagePaths[img] + "' for image '" + img + "'");
    }
    return imagePaths[img];
}
export function setRandomRotations(elems, range) {
    const ang = getRandomBetween(-range, range);
    for (let elem of elems)
        setRotation(elem, ang);
}
export function setRandomRotation(elem, range) {
    setRotation(elem, getRandomBetween(-range, range));
}
export function setRotations(elems, ang) {
    for (let elem of elems)
        setRotation(elem, ang);
}
export function setRotation(elem, ang) {
    elem.style.transformOrigin = "center";
    elem.style.transform = elem.style.transform + " rotate(" + ang + "deg)";
}
export function mirrorXs(elems) {
    for (let elem of elems)
        mirrorX(elem);
}
export function mirrorX(elem) {
    elem.style.transformOrigin = "center";
    elem.style.transform = elem.style.transform + " scaleX(-1)";
}
export function getArrayIndex(cols, rows, x, y) {
    if (x < 0 || y < 0) {
        console.log("Negative tile position @ " + x + ", " + y + "!");
        console.trace();
        return 0;
    }
    if (x >= cols || y >= rows) {
        console.log("OOB tile position @ " + x + ", " + y + "!");
        console.trace();
        return 0;
    }
    if (x != Math.floor(x) || y != Math.floor(y)) {
        console.log("Noninteger tile position @ " + x + ", " + y + "!");
        console.trace();
        return 0;
    }
    return x + y * cols;
}
